export enum REPORT_REQUEST_ID_LIST {
  GET_REPORT = 'GET_REPORT',
  GET_SHOP_LIST = 'GET_SHOP_LIST',
  GET_CONFIG_AND_SHOP_LIST = 'GET_CONFIG_AND_SHOP_LIST',
  GET_DOWNLOAD = 'GET_DOWNLOAD',
  VERIFY_EMAIL = 'VERIFY_EMAIL',
  GET_CONFIRM_EMAIL = 'GET_CONFIRM_EMAIL',
  POST_EMAIL_VAT_ADDRESS = 'POST_EMAIL_VAT_ADDRESS',
  POST_EMAIL_SHOP = 'POST_EMAIL_SHOP',
  POST_EMAIL_RESEND = 'POST_EMAIL_RESEND',
  PATCH_REPORT_TYPE = 'PATCH_REPORT_TYPE',
}

export enum REPORT_TYPE {
  STM = 'STM',
  TNV = 'TNV',
  RNV = 'RNV',
  CDN = 'CDN',
  RCN = 'RCN'
}

export enum REPORT_TRANSLATION_KEY {
  BATCH_PERIOD_ERROR  = 'batch.period.error',
}

export const T_DATE_SELECT = 1;
export const REPORT_EMAIL_MAX_LENGTH = 150;
export const BATCH_REPORT_START = '23:00';
export const BATCH_REPORT_END = '01:00';

export enum EMAIL_VERIFICATION_STATUS {
  SUCCESS = 'success',
  EXPIRED = 'link_expired',
  ALREADY_VERIFIED = 'already_confirm',
  ERROR = 'error'
}
